<template>
  <div class="form-wrap">
    <label :for="toKebabCase(name)">{{ name }}{{ labelOptional ? ` (${$t('meta.optional')})` : '' }}</label>
    <input
      :id="toKebabCase(name)"
      class="form-input"
      :type="type"
      :disabled="disabled"
      @input="handleInput"
      :value="value"
      :min="min"
      :step="step"
      :placeholder="placeholder"
      :required="required"
      @keypress.enter.self.prevent
    />
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'FormInput',
  props: {
    disabled: { default: false, required: false, type: Boolean },
    labelOptional: { default: false, required: false, type: Boolean },
    min: { required: false, type: [String, Number] },
    name: { required: true, type: String },
    placeholder: { required: false, type: String },
    required: { required: false, type: Boolean },
    step: { required: false, type: [String, Number] },
    type: { default: 'text', required: false, type: String },
    value: { type: [String, Number] },
  },
  mixins: [stringUtils],
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    },
  },
}
</script>
